export type CardType = 'plot' | 'character' | 'setting' | 'conflict' | 'theme' | 'note' | 'ai-context-prompt';

export interface PlotLine {
  id: number;
  name: string;
  description: string;
  color?: string;
  created_at?: string;
  updated_at?: string;
  _order?: number | null; // Virtual field for in-memory ordering only (not stored in DB)
}

export interface Chapter {
  id: number;
  name: string;
  title?: string;
  description: string;
  created_at: string;
  updated_at: string;
  _order?: number | null; // Virtual field for in-memory ordering only (not stored in DB)
}

export interface Entity {
  id: number;
  name: string;
  description?: string;
  template_id: number;
  template_name?: string;
}

export interface Tag {
  id: number;
  name: string;
  color: string;
  description?: string;
}

export interface PlotCard {
  id: number;
  title: string;
  content: string;
  type: CardType;
  x: number;
  y: number;
  value?: string; // Making value optional since we're using content instead
  created_at: string;
  updated_at: string;
  chapter_id?: number | null; // Add chapter_id to track which chapter this card belongs to
  position?: number | null; // Add position to track the order within a chapter
  entities?: Entity[]; // Entities attached to this card
  tags?: Tag[]; // Tags attached to this card
}

export interface TimelineState {
  plotLines: PlotLine[];
  chapters: Chapter[];
  plotCards: PlotCard[];
  timeline?: any; // Timeline object
  settings?: any; // Timeline settings
  storyId?: string; // Current story ID
  projectId?: string; // Current project ID
}

export const cardTypeColors: Record<CardType, { bg: string, border: string, hover: string, text: string }> = {
    plot: {
        bg: "bg-blue-500/5",
        border: "border-blue-500/20",
        hover: "hover:bg-blue-500/10",
        text: "text-blue-400"
    },
    character: {
        bg: "bg-emerald-500/5",
        border: "border-emerald-500/20",
        hover: "hover:bg-emerald-500/10",
        text: "text-emerald-400"
    },
    setting: {
        bg: "bg-violet-500/5",
        border: "border-violet-500/20",
        hover: "hover:bg-violet-500/10",
        text: "text-violet-400"
    },
    conflict: {
        bg: "bg-rose-500/5",
        border: "border-rose-500/20",
        hover: "hover:bg-rose-500/10",
        text: "text-rose-400"
    },
    theme: {
        bg: "bg-amber-500/5",
        border: "border-amber-500/20",
        hover: "hover:bg-amber-500/10",
        text: "text-amber-400"
    },
    note: {
        bg: "bg-zinc-500/5",
        border: "border-zinc-500/20",
        hover: "hover:bg-zinc-500/10",
        text: "text-zinc-400"
    },
    "ai-context-prompt": {
        bg: "bg-teal-500/5",
        border: "border-teal-500/20",
        hover: "hover:bg-teal-500/10",
        text: "text-teal-400"
    }
};